// Canton mapping system for team registration
// Maps old canton selections to new consolidated canton structure

// Mapping from old canton codes to new consolidated cantons
export const CANTON_MAPPING = {
  // Appenzell consolidation
  'AR': 'Appenzell',  // Appenzell Ausserrhoden -> Appenzell
  'AI': 'Appenzell',  // Appenzell Innerrhoden -> Appenzell
  
  // Basel consolidation  
  'BL': 'Basel',      // Basel-Landschaft -> Basel
  'BS': 'Basel',      // Basel-Stadt -> Basel
  
  // Nidwalden consolidation
  'NW': 'Nidwalden',  // Nidwalden -> Nidwalden (same name)
  'OW': 'Nidwalden',  // Obwalden -> Nidwalden
  'UR': 'Nidwalden',  // Uri -> Nidwalden
  
  // Grisons rename
  'GR': 'Grisons',    // Graubünden -> Grisons
  
  // All other cantons remain the same
  'ZH': 'ZH',         // Zurich
  'BE': 'BE',         // Bern
  'LU': 'LU',         // Lucerne
  'SZ': 'SZ',         // Schwyz
  'GL': 'GL',         // Glarus
  'ZG': 'ZG',         // Zug
  'FR': 'FR',         // Fribourg
  'SO': 'SO',         // Solothurn
  'SH': 'SH',         // Schaffhausen
  'SG': 'SG',         // St. Gallen
  'AG': 'AG',         // Aargau
  'TG': 'TG',         // Thurgau
  'TI': 'TI',         // Ticino
  'VD': 'VD',         // Vaud
  'VS': 'VS',         // Valais
  'NE': 'NE',         // Neuchâtel
  'GE': 'GE',         // Geneva
  'JU': 'JU'          // Jura
};

// Reverse mapping for display purposes
export const REVERSE_CANTON_MAPPING = {
  'Appenzell': ['AR', 'AI'],
  'Basel': ['BL', 'BS'],
  'Nidwalden': ['NW', 'OW', 'UR'],
  'Grisons': ['GR']
};

// Get the new canton code for a given old canton code
export const mapToNewCanton = (oldCantonCode) => {
  return CANTON_MAPPING[oldCantonCode] || oldCantonCode;
};

// Get all old canton codes that map to a new canton
export const getOldCantonCodesForNew = (newCantonCode) => {
  return Object.keys(CANTON_MAPPING).filter(code => CANTON_MAPPING[code] === newCantonCode);
};

// Check if a canton code is part of a consolidated canton
export const isConsolidatedCanton = (cantonCode) => {
  return Object.values(CANTON_MAPPING).includes(cantonCode);
};

// Get the display name for a new canton code
export const getNewCantonDisplayName = (newCantonCode) => {
  const displayNames = {
    'Appenzell': 'Appenzell',
    'Basel': 'Basel', 
    'Nidwalden': 'Nidwalden',
    'Grisons': 'Grisons'
  };
  return displayNames[newCantonCode] || newCantonCode;
};

// Get all new consolidated canton codes
export const getNewCantonCodes = () => {
  return [...new Set(Object.values(CANTON_MAPPING))];
};

// Get all old canton codes (for registration form)
export const getOldCantonCodes = () => {
  return Object.keys(CANTON_MAPPING);
};

// Validation function to ensure mapping is complete
export const validateCantonMapping = () => {
  const allOldCodes = Object.keys(CANTON_MAPPING);
  const allNewCodes = Object.values(CANTON_MAPPING);
  
  console.log('🔍 Canton Mapping Validation:');
  console.log(`Total old canton codes: ${allOldCodes.length}`);
  console.log(`Total new canton codes: ${allNewCodes.length}`);
  console.log(`Unique new canton codes: ${new Set(allNewCodes).size}`);
  
  return {
    totalOldCodes: allOldCodes.length,
    totalNewCodes: allNewCodes.length,
    uniqueNewCodes: new Set(allNewCodes).size,
    isValid: allOldCodes.length === 26 // Should be 26 Swiss cantons
  };
};
